var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9321 11.6202V2.509C20.9321 1.25621 19.9071 0.231201 18.6543 0.231201H2.70969C1.4569 0.231201 0.431885 1.25621 0.431885 2.509V11.6202C0.431885 12.873 1.4569 13.898 2.70969 13.898H18.6543C19.9071 13.898 20.9321 12.873 20.9321 11.6202ZM10.682 10.4813C8.79141 10.4813 7.26529 8.95518 7.26529 7.0646C7.26529 5.17403 8.79141 3.6479 10.682 3.6479C12.5726 3.6479 14.0987 5.17403 14.0987 7.0646C14.0987 8.95518 12.5726 10.4813 10.682 10.4813ZM25.4877 3.6479V16.1758C25.4877 17.4286 24.4627 18.4536 23.2099 18.4536H3.84859V16.1758H23.2099V3.6479H25.4877Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.df65546430b7b629108b599ca1325b40.svg";
export { ForwardRef as ReactComponent };